import Vue from "vue";
import VueRouter from "vue-router";
import {beeshop} from "./beeshop";
import store from "../store/index"

Vue.use(VueRouter);

const routes = [
    {
        path: "/login",
        name: "login",
        meta: {},
        component: () => import("../views/user/login.vue")
    },
    {
        path: "/",
        name: "",
        meta: {},
        component: () => import("../views/home.vue")
    },
    {
        path: "/home",
        name: "home",
        meta: {},
        component: () => import("../views/home.vue")
    },
    ...beeshop,
    {
        path: "*",
        name: "page-not-found",
        meta: {},
        component: () => import("../views/pageNotFound.vue")
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

export default router;

router.beforeEach((to, from, next) => {
   
    if(to.name==="login"){
        store.state.userDoc.id = "";
        store.state.userDoc.username = "";
        store.state.userDoc = {};
        if(store.state.userDoc.phone){ store.state.userDoc.phone = ""; } // just append so some where will not
        localStorage.clear();
    }
    else if(
        to.name === 'beeshop.agri-input.reporting.report' || 
        to.name === 'beeshop.agri-input.reporting.stock-reconcile' || 
        to.name === 'beeshop.agri-input.reporting.stock-reconcile-list' || 
        to.name === 'beeshop.agri-input.reporting.stock-reconcile-detail' || 
        to.name === 'beeshop.agri-input.reporting.stock-report' || 
        to.name === 'beeshop.agri-input.reporting.supplier-stock-report' || 
        to.name === 'beeshop.agri-input.reporting.stock-detail-report'
        ){
            next();
        }

    else{
        if(! localStorage.phone){
            router.push({name: 'login'}).catch(err => {console.log(err)});
        }
    }
    next();
});